import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import contractRefundStatusAuditLogListApi from './list/Api.ContractRefundStatusAuditLog.List';

export default class ContractRefundStatusAuditLog
  extends Model<Model.IContractRefundStatusAuditLog>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundStatusAuditLog>
{
  id: number;
  oldStatus?: Model.Enum.ContractRefundStatusCode;
  newStatus?: Model.Enum.ContractRefundStatusCode;
  createdAtUtc: string;
  modifiedAtUtc: string;
  contractRefundId: number;
  createdBy?: User;
  createdById?: number;
  modifiedBy?: User;
  modifiedById?: number;

  constructor(
    data: Partial<Model.IContractRefundStatusAuditLog> | Utils.FormData<Model.IContractRefundStatusAuditLog>,
    language?: Locale.Languages
  ) {
    super(
      {
        createdBy: User,
        modifiedBy: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this?.oldStatus,
      info: this?.newStatus,
    };
  }

  static async list(body?: Api.Sales.ContractRefundStatusAuditLog.List.IRequest) {
    const { payload, ...rest } = await contractRefundStatusAuditLogListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundStatusAuditLog(it)),
        count: payload.count,
      },
    };
  }
}
